"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return zipIS2;
    }
});
const _jszip = /*#__PURE__*/ _interop_require_default(require("jszip"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function zipIS2(buffer, info, preview) {
    const zip = new _jszip.default();
    try {
        await zip.loadAsync(buffer);
        // get /Thumbnails contents -->
        const thumbnailFolder = "Thumbnails/";
        const thumbnailFiles = Object.keys(zip.files).filter((file)=>file.startsWith(thumbnailFolder) && file !== thumbnailFolder);
        const thumbnailFileName = thumbnailFiles[0];
        // Remove the existing files and add the updated files
        zip.remove(thumbnailFileName);
        zip.remove("info.json");
        zip.file(thumbnailFileName, preview);
        // pack updated files
        zip.file("info.json", JSON.stringify(info));
        const zipBuffer = await zip.generateAsync({
            type: "arraybuffer"
        });
        return zipBuffer;
    } catch (error) {
        console.error("Error packing files:", error);
        throw error;
    }
}
